import { CuentaBancaria } from "./cuenta-bancaria";
import { MovimientoDetalle } from "./movimiento_detalle";

export class ConciliacionBancaria{
    public constructor(
        public descripcion:string = "",
        public fecha_corte:string = "",
        public saldo_bancario:string = "",
        public saldo_contable:string = "",
        public saldo_inicial:string = "",
        public saldo_final:string = "",
        public diferencia:string = "",
        public cuenta_bancaria_id: string = "",
        // public status:string="",
        public empresa_id:string = "",
        public usuario_id:string = null,
        public detalle: Array<MovimientoDetalle> = [],
        public detalle_false: Array<MovimientoDetalle> = [],

        public cuentabancaria : CuentaBancaria = new CuentaBancaria(),
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/conciliacion-bancaria.ts